import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bubble- box-speech",
  "use": "bubble- box-speech-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"bubble- box-speech\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 0C.758 0 0 .756 0 2v8c0 1.245.758 2 2 2h3l3 3 3-3h3c1.242 0 2-.756 2-2V2c0-1.245-.758-2-2-2H2zM1 10V2c0-.418.588-1 1-1h12c.412 0 1 .582 1 1v8c0 .418-.588 1-1 1h-3.5L8 13.5 5.5 11H2c-.412 0-1-.582-1-1zm3-6h8v1H4V4zm7 3H4v1h7V7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol